(function() {
    angular.module('emarket.commons').directive('preview', ['$log', '$document', '$timeout', function($log, $document, $timeout) {
        return {
            scope: {
                content: '='
            },
            templateUrl: 'directives/preview/preview.tpl.html',
            link: function link(scope, element) {
                element.addClass('preview');
                var iframe = $(element).find('iframe')[0];
                scope.loading = true;
                var resizeIframe = function() {
                    $timeout(function() {
                        iframe.style.height = $(iframe.contentWindow.document)
                            .find('html')
                            .css('height');
                        scope.loading = false;
                    }, 300);
                };
                iframe.contentDocument.body.innerHTML = scope.content;
                iframe.contentDocument.body.style.margin = 0;
                iframe.contentDocument.body.style['word-wrap'] = 'break-word';

                var imgs = $(iframe.contentWindow.document).find('img');
                var total = imgs.length;
                var count = 0;
                imgs.css('max-width', '100%');

                imgs.on('load', function() {
                    count++;
                    if (count >= total) {
                        resizeIframe();
                    }
                });
                imgs.on('error', function() {
                    count++;
                    if (count >= total) {
                        resizeIframe();
                    }
                });
                if (imgs.length === 0) {
                    resizeIframe();
                }
            }
        };
    }]);
}());
